export default __webpack_public_path__ + "static/cryonis-3ddcea058f5d30a67370202793162e2f.png";